import { types } from '../actions/types';

export const LeadReducer = (
  state = {
    get: null,
    items: null,
    create: null,
    users: null,
    update: null,
    updateOrder: null,
    getById: null,
  },
  action,
) => {
  switch (action.type) {
    case types.lmGetLeads:
      return {
        ...state,
        get: {
          status: action.payload?.status,
          message: action.payload?.message,
          data: action.payload?.data,
        },
      };
    case types.lmGetLeadItems:
      return {
        ...state,
        items: {
          status: action.payload?.status,
          message: action.payload?.message,
          data: action.payload?.data,
        },
      };
    case types.lmCreateLead:
      return {
        ...state,
        create: {
          status: action.payload?.status,
          message: action.payload?.message,
          data: action.payload?.data,
        },
      };
    case types.lmGetLeadUsers:
      return {
        ...state,
        users: {
          status: action.payload?.status,
          message: action.payload?.message,
          data: action.payload?.data,
        },
      };
    case types.lmUpdateLead:
      return {
        ...state,
        update: {
          status: action.payload?.status,
          message: action.payload?.message,
          data: action.payload?.data,
        },
      };
    case types.lmUpdateLeadOrder:
      return {
        ...state,
        updateOrder: {
          status: action.payload?.status,
          message: action.payload?.message,
          data: action.payload?.data,
        },
      };
    case types.lmGetLeadById:
      return {
        ...state,
        getById: {
          status: action.payload?.status,
          message: action.payload?.message,
          data: action.payload?.data,
        },
      };
    default:
      return state;
  }
};
